import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import MenuItems from './MenuItems';
import topMenuQuery from './topMenuQuery';

// TODO fix this \\//
import Menu from '../TopMenu/Menu';
import SSRAwareQuery from '../SSRAwareQuery';

const NAV_STICKY_OFFSET = 100;

const HeaderMenu = props => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const onScroll = event => {
      const itHasScrolled = window.pageYOffset > NAV_STICKY_OFFSET;

      if (itHasScrolled !== hasScrolled) {
        setHasScrolled(itHasScrolled);
      }
    };

    window.addEventListener('scroll', onScroll);
    setHasScrolled(window.pageYOffset > NAV_STICKY_OFFSET);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [hasScrolled]);

  return (
    <SSRAwareQuery query={topMenuQuery}>
      {({ loading, error, data }) => {
        // Loading placeholder
        if (loading && (!data.application || !data.application.mainMenu)) {
          return <Menu children={<Logo hasScrolled={hasScrolled} />} />;
        }
        if (error) {
          throw error;
        }

        const { mainMenu, userMenu } = data.application;

        return (
          <>
            <Logo hasScrolled={hasScrolled} />
            <MenuItems
              mainMenu={mainMenu}
              userMenu={userMenu}
              hasScrolled={hasScrolled}
            />
          </>
        );
      }}
    </SSRAwareQuery>
  );
};

export default HeaderMenu;
